import { CARD_STYLED_PROPS } from "./interface"
import styled from "styled-components"
import { cardAnimations } from "./animations/cardAnimations"

const { dealIn, scale, bankerDealOut, playerDealOut } = cardAnimations()

export const CardContainer = styled.div<CARD_STYLED_PROPS>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  left: ${({ left }) => left + "px" || 0};
  bottom: ${({ bot }) => bot + "px" || 0};
`
export const CardWrapper = styled.div<CARD_STYLED_PROPS>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  transform: ${({ betReply }) =>
    betReply
      ? " translate(0,0) rotate(0)"
      : " translate(320px, -510px) rotate(-180deg)"};
  //animation
  ${({ deal }) => deal && dealIn}
  animation-delay: ${({ animDelay }) => animDelay + "s"};
`

export const CardDiv = styled.div<CARD_STYLED_PROPS>`
  border-radius: 10px;
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto 0;
  position: absolute;
  padding: ${({ pad }) => pad || "12px"};
  //dynamic styles
  height: ${({ height }) => height || "157px"};
  width: ${({ width }) => width || "102px"};
  background: ${({ background }) => background};
  transition: ${({ showResult }) => showResult && "background 0.3s linear"};
  ${({ showResult, win }) => showResult && win && scale}
  ${({ dealOut, name }) =>
    dealOut && (name === "banker" ? bankerDealOut : playerDealOut)}
  animation-delay: 0.3s;
  p {
    font-size: ${({ size }) => size || "16px"};
    color: ${({ suitColor }) => suitColor};
    transition: ${({ showResult }) => showResult && "color 0.3s linear"};
  }
  svg {
    path {
      fill: ${({ suitColor }) => suitColor};
      transition: ${({ showResult }) => showResult && "fill 0.3s linear"};
    }
  }
`

export const SuitStyled = styled.div<CARD_STYLED_PROPS>`
  svg {
    min-height: ${({ suitSize }) => suitSize || "36px"};
    min-width: ${({ suitSize }) => suitSize || "44px"};
    width: ${({ suitSize }) => suitSize || "36px"};
    height: ${({ suitSize }) => suitSize || "44px"};
  }
`
export const SideSymbols = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 7px;
  top: 10px;
`
